/* eslint-disable react-hooks/exhaustive-deps */
// -- == //
import React, { useEffect } from 'react';
import { Formik } from 'formik';

import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';
import TextIput from 'components/form/textInput';
import { useActions } from 'common/hooks/useActions';
import Dropdown from 'components/form/dropDown';
import TextArea from 'components/form/texArea';

import * as S from '../../styles';
import * as T from 'common/types';
import { useNavigate } from 'react-router-dom';
import { ValidationCreateDepFloorNotif } from 'common/validations';

interface IProps {
  data?: any;
  departments: string[];
  closeModal?: () => void;
  fetchData?: () => void;
  floors: { list: any[] };
}

const DepartmentAndFloorForm: React.FC<IProps> = ({ data, departments, floors }) => {
  const nav = useNavigate();
  const { departmentsRequestAction, floorsRequestAction, notficationCreateCustomRequestAction } = useActions();

  useEffect(() => {
    departmentsRequestAction();
    floorsRequestAction({ getAll: true });
  }, []);

  return (
    <Formik
      initialValues={{
        title: data?.title || '',
        department: data?.department || '',
        body: data?.body || '',
        floor: data?.floor || '',
        floorName: data?.floor || '',
        sendToAll: false
      }}
      enableReinitialize
      validationSchema={ValidationCreateDepFloorNotif}
      onSubmit={(values, { setSubmitting }) => {
        notficationCreateCustomRequestAction(values, () => {
          nav('/panel/notifications');
        });
        setSubmitting(false);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setValues }) => (
        <>
          <S.Body>
            <S.Grid2>
              <S.Rows>
                <TextIput
                  type="text"
                  name="title"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Notification title"
                  label="Title"
                  required
                  value={values.title}
                  message={touched.title && (errors.title as any)}
                  error={touched.title && (errors.title as unknown as boolean)}
                />

                <TextArea
                  label="Message"
                  required
                  name="body"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="What should people see?"
                  value={values.body}
                  message={touched.body && (errors.body as any)}
                  error={touched.body && (errors.body as unknown as boolean)}
                  help="Sent as a push notification. Keep it under two lines."
                />
              </S.Rows>

              {/* Who receives it, in its own column — the design's grid-2. */}
              <S.Rows>
                <Dropdown
                  list={departments?.map((item: string) => {
                    return { id: item, title: item };
                  })}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      department: e.id as string
                    });
                  }}
                  label="Department"
                  required
                  placeholder="Select a department"
                  defaultValue={{
                    title: values.department,
                    id: values.department
                  }}
                  message={touched.department && (errors.department as any)}
                  error={touched.department && (errors.department as unknown as boolean)}
                />

                <Dropdown
                  list={floors?.list
                    ?.filter((item: T.Pages.FloorListItem) => !item.isDeleted)
                    ?.map((item: T.Pages.FloorListItem) => {
                      return { id: item.id, title: item.name };
                    })}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      floor: e.id as string,
                      floorName: e.title
                    });
                  }}
                  label="Floor"
                  required
                  placeholder="Select a floor"
                  defaultValue={{
                    title: values.floorName,
                    id: values.floor
                  }}
                  message={touched.floor && (errors.floor as any)}
                  error={touched.floor && (errors.floor as unknown as boolean)}
                />
              </S.Rows>
            </S.Grid2>
          </S.Body>

          <S.Actions>
            <OutlineButton link="/panel/notifications">Cancel</OutlineButton>
            <PrimaryButton onClick={handleSubmit}>Send notification</PrimaryButton>
          </S.Actions>
        </>
      )}
    </Formik>
  );
};

export default DepartmentAndFloorForm;
